import React, { useEffect, useState, useRef } from 'react';
import './CaseStudies.css';

import { CaseItem, CaseTabs } from '..';
import { cases } from '../../constants';

import Isotope from 'isotope-layout';
import Lightbox from "react-18-image-lightbox";
import "react-18-image-lightbox/style.css";



const CaseStudies = () => {

  // State
  const [category, setCategory] = useState('all');
  const iso = useRef(null);
  const gridRef = useRef(null);

  // Lightbox State
  const [index, setIndex] = useState(-1);
  const currentImage = cases[index];
  const nextIndex = (index + 1) % cases.length;
  const nextImage = cases[nextIndex] || currentImage;
  const prevIndex = (index + cases.length - 1) % cases.length;
  const prevImage = cases[prevIndex] || currentImage;

  const openLightbox = (index) => setIndex(index);
  const closeLightbox = () => setIndex(-1);
  const handleMovePrev = () => setIndex(prevIndex);
  const handleMoveNext = () => setIndex(nextIndex);

  // Function to format category names as Isotope classes
  const formatCategory = (name) => name.toLowerCase().replace(/\s+/g, '-');

  // Get unique categories from cases
  const categories = ['all', ...new Set(cases.map(item => formatCategory(item.details.category)))];

  // Initialize Isotope
  useEffect(() => {
    iso.current = new Isotope(gridRef.current, {
      itemSelector: '.case-item',
      layoutMode: 'fitRows',
    });

    return () => {
      iso.current.destroy();
    };
  }, []);

  // Apply filter when category changes
  useEffect(() => {
    if (iso.current) {
      iso.current.arrange({
        filter: category === 'all' ? '*' : `.${category}`, // Filters by class name
      });
    }
  }, [category]);

  return (
    <div className='case-studies'>

      {/* Case Study Tabs */}
      <ul className="tab-buttons">
        {categories.map((item) => (
          <CaseTabs
            key={item}
            id={item}
            title={item.replace(/-/g, ' ')} // Show original category name
            setSelected={() => setCategory(item)}
            active={category === item}
          />
        ))}
      </ul>

      {/* Case Studies */}
      <div className="box-container" ref={gridRef}>
        {cases.map((item, index) => {
          const className = formatCategory(item.details.category);
          return (
            <CaseItem
              key={item.id}
              id={index}
              image={item.image}
              title={item.title}
              category={item.details.category}
              caseStudy={item}
              className={className} // Add class for Isotope filtering
              popup={openLightbox}
            />
          );
        })}
      </div>

      {/* Lightbox */}
      {index !== -1 && (
        <Lightbox
          mainSrc={currentImage.image}
          imageTitle={currentImage.title}
          mainSrcThumbnail={currentImage.image}
          nextSrc={nextImage.image}
          nextSrcThumbnail={nextImage.image}
          prevSrc={prevImage.image}
          prevSrcThumbnail={prevImage.image}
          onCloseRequest={closeLightbox}
          onMovePrevRequest={handleMovePrev}
          onMoveNextRequest={handleMoveNext}
        />
      )}
    </div>
  );
};

export default CaseStudies;